import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Layout from '@/components/feature/Layout';

export default function About() {
  const { t } = useTranslation();

  return (
    <Layout>
      <section className="relative pt-32 pb-20 md:pt-40 md:pb-28 bg-primary-800 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full bg-accent-500 blur-3xl" />
          <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full bg-accent-400 blur-3xl" />
        </div>
        <div className="relative z-10 max-w-[1280px] mx-auto px-6 md:px-10 lg:px-16 text-center">
          <p className="text-xs font-semibold uppercase tracking-widest text-accent-300 mb-4">
            {t('about.label')}
          </p>
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
            {t('aboutPage.heroTitle')}
          </h1>
          <p className="text-base text-foreground-200 max-w-[600px] mx-auto leading-relaxed">
            {t('aboutPage.heroSubtitle')}
          </p>
        </div>
      </section>

      <section className="py-20 md:py-28 px-6 md:px-10 lg:px-16 bg-background-50">
        <div className="max-w-[900px] mx-auto">
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start">
            <div className="lg:w-[320px] flex-shrink-0">
              <div className="w-full aspect-[3/4] rounded-2xl overflow-hidden">
                <img
                  src="https://storage.readdy-site.link/project_files/37408e67-6c6c-467a-b6a7-109b0b149024/1ad4ef46-cd97-425d-baf6-0e1570e557c1_compressed_Designer-1.webp?__preview_ts=2026-06-19T09%3A10%3A19.806905Z"
                  alt={t('aboutPage.heroTitle')}
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
            <div className="flex-1">
              <div className="space-y-5">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {t('aboutPage.bio1')}
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {t('aboutPage.bio2')}
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {t('aboutPage.bio3')}
                </p>
              </div>

              <div className="grid grid-cols-2 gap-5 mt-10">
                <div className="bg-accent-500 rounded-2xl p-6 text-center">
                  <div className="font-heading text-5xl md:text-6xl font-bold text-white mb-1">
                    {t('about.stats1.number')}<span className="text-2xl">{t('about.stats1.suffix')}</span>
                  </div>
                  <p className="text-xs text-white/80 leading-relaxed">
                    {t('about.stats1.description')}
                  </p>
                </div>
                <div className="bg-primary-800 rounded-2xl p-6 text-center">
                  <div className="font-heading text-5xl md:text-6xl font-bold text-white mb-1">
                    {t('about.stats2.number')}<span className="text-2xl">{t('about.stats2.suffix')}</span>
                  </div>
                  <p className="text-xs text-foreground-200 leading-relaxed">
                    {t('about.stats2.description')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 md:py-28 px-6 md:px-10 lg:px-16 bg-background-100">
        <div className="max-w-[900px] mx-auto">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-12 text-center">
            {t('aboutPage.approachTitle')}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-7">
            {[1, 2, 3].map((idx) => (
              <div
                key={idx}
                className="bg-white rounded-2xl p-7 border border-background-200/70 hover:border-accent-200 transition-all duration-300"
              >
                <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center mb-5">
                  <span className="font-heading text-lg font-bold text-accent-600">{idx}</span>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {t(`aboutPage.approach${idx}`)}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 px-6 md:px-10 lg:px-16 bg-primary-500">
        <div className="max-w-[700px] mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-4">
            {t('aboutPage.cta')}
          </h2>
          <Link
            to="/booking"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-white text-primary-700 font-semibold text-sm rounded-full hover:bg-accent-100 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            {t('hero.cta1')}
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </section>
    </Layout>
  );
}